<template>
    <a-modal :title="title" width="750px" :maskClosable="false" :visible.sync="show" @cancel="() => $emit('update:show', false)" :footer="null" :getContainer="() => $parent.$el">
        <a-table :row-key="record => record.id" :data-source="items" bordered :pagination="false">
            <a-table-column data-index="name" ellipsis width="200px">
                <span slot="title">归属人</span>
                <template slot-scope="text, record">
                    <a-tag color="#2db7f5">
                        {{ record.owner.id }}
                    </a-tag>
                    {{ record.owner.name }}
                </template>
            </a-table-column>
            <a-table-column data-index="info" ellipsis>
                <span slot="title">证书信息</span>
                <template slot-scope="text, record">
                    {{ record.name }} [ {{ record.sno }} ]
                    <a-tag color="#f50">
                        {{ record.type | fmtCertType }}
                    </a-tag>
                    <a-tag color="#108ee9">
                        {{ record.grade | fmtCertGrade }}
                    </a-tag>
                    <a-tag color="#87d068">
                        {{ record.level }}
                    </a-tag>
                </template>
            </a-table-column>
        </a-table>
        <a-form-model ref="form" :style="{ marginTop: '16px' }" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="审核结果" prop="pass">
                <a-radio-group v-model="field.pass">
                    <a-radio value="true">
                        通过
                    </a-radio>
                    <a-radio value="false">
                        驳回
                    </a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="审核说明" prop="memo">
                <a-input v-model="field.memo" placeholder="请填写审核说明信息" />
            </a-form-model-item>
            <a-form-model-item label="数据来源" prop="dsrc">
                <a-input v-model="field.dsrc" placeholder="请填写审核依据数据来源" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doAudit" icon="issues-close">
                    提交审核
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            field: {
                ids: '',
                pass: 'true',
                memo: '已核实，通过审核',
                dsrc: ''
            },
            rules: {
                pass: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
                memo: [{ required: true, message: '请填写审核说明', trigger: 'blur' }],
                dsrc: [{ required: true, message: '请填写数据来源', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        this.field.ids = this.items.map(item => item.id).join()
    },
    methods: {
        doAudit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/crs/cert/plat/info/audit', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('审核成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            this.field.ids = this.items.map(item => item.id).join()
        }
    }
}
</script>
